import { computed } from 'vue'
import device from 'current-device'

export function useMobile() {
  const isMobile = computed<boolean>(() => {
    // Chrome version >= 101
    if (navigator?.userAgentData?.mobile) return true

    const userAgentCheck = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

    if (userAgentCheck) return true

    // to really make sure, we can also check the device type using the 'current-device' library
    return device.mobile() || device.tablet()
  })

  return {
    isMobile,
  }
}
